import { SPACE, THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
		// The fullscreen modal body is edge-to-edge — constrain to a centered, readable column.
		width: '100%',
		maxWidth: 640,
		margin: '0 auto',
		padding: `${THEME.spacing.xl}px ${THEME.spacing.lg}px ${THEME.spacing.xxl}px`,
		boxSizing: 'border-box',
	},
	title: {
		fontFamily: THEME.typography.fontFamilies.sora,
		fontSize: THEME.typography.fontSizes.lg,
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.text.main,
	},
	detail: {
		fontFamily: THEME.typography.fontFamilies.lexend,
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.light,
	},
	/** The sole available format, shown in place of a picker — a value, not helper text. */
	formatValue: {
		fontFamily: THEME.typography.fontFamilies.lexend,
		fontSize: THEME.typography.fontSizes.md,
		color: THEME.colors.text.main,
	},
	hiddenField: {
		display: 'none',
	},
	choiceGroup: {
		display: 'grid',
		gap: SPACE[8],
		gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
		[THEME.queries.sm]: {
			gridTemplateColumns: 'repeat(1, minmax(0, 1fr))',
		},
	},
	field: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
	},
	label: {
		fontFamily: THEME.typography.fontFamilies.lexend,
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.semibold,
		color: THEME.colors.text.main,
	},
	selectTrigger: {
		width: '100%',
	},
	collapseToggle: {
		gap: THEME.spacing.sm,
		justifyContent: 'space-between',
		width: '100%',
	},
	collapseChevron: {
		flexShrink: 0,
		transition: 'transform 0.15s ease',
		'@media (prefers-reduced-motion: reduce)': {
			transition: 'none',
		},
	},
	collapseChevronOpen: {
		transform: 'rotate(180deg)',
	},
	// Only the questionnaire scrolls, so the grip and the toggle above it stay put while it does.
	containerCollapsible: {
		minHeight: 0,
	},
	/** Separates the short-notice ask from the last question above it. */
	shortNotice: {
		marginTop: THEME.spacing.md,
	},
	scrollingForm: {
		flex: 1,
		minHeight: 0,
		overflowY: 'auto',
	},
	resizeHandle: {
		alignItems: 'center',
		cursor: 'ns-resize',
		display: 'flex',
		height: 14,
		justifyContent: 'center',
		touchAction: 'none',
	},
	resizeGrip: {
		background: THEME.colors.border.main,
		borderRadius: THEME.common.borderRadiusSm,
		height: 4,
		width: 32,
	},
});
